import { ClubWizard } from './ClubWizard';

export default ClubWizard;
